module.exports = __webpack_public_path__ + "assets/img/33_1573.81cc7df1.jpg";